import { useCallback, useEffect } from 'react';
import type { Dispatch } from 'react';

import type { HotelOffersState } from '../types/hotel-offers';
import type {
  GetHotelDetailPriceRequest,
  GetHotelDetailPriceResponse,
} from '@shared/types/frontend/ubff/hotel-detail-price';
import type { UBFFGateway } from '@shared/types/frontend/ubff-gateway';

type Props = {
  uBFFGateway: UBFFGateway;
  request: GetHotelDetailPriceRequest;
  setState: Dispatch<Partial<HotelOffersState>>;
};

const useHotelOffersFetch = ({ request, setState, uBFFGateway }: Props) => {
  const fetchResults = useCallback(async () => {
    const { error, response } = await uBFFGateway.pollHotelOffers(request);
    if (error) {
      setState({ error });
    } else if (response) {
      setState({ response: response as GetHotelDetailPriceResponse });
    }
  }, [request, setState, uBFFGateway]);

  useEffect(() => {
    fetchResults();
  }, [request, fetchResults]);

  return { fetchResults };
};

export default useHotelOffersFetch;
